import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import CustomButton from "../Buttons/Button";
import { generateInvestmentStatement } from "../../store/actions/userManagement/generateInvestmentStatement";
import { generateWalletStatement } from "../../store/actions/userManagement/generateWalletStatement";

const statementOptions = [
  { value: "investment", label: "Investment Statement" },
  { value: "wallet", label: "Wallet Statement" },
];

const currencyOptions = [
  { value: "NGR", label: "Nigerian Naira (₦)" },
  { value: "USD", label: "United State Dollars ($)" },
];

function GenerateStatementModal({ open, onClose, user }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [statementType, setStatementType] = useState("investment");
  const [currency, setCurrency] = useState("NGR");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const handleGenerate = () => {
    if (!dateFrom || !dateTo) {
      toast.error("Please select both a start and end date.");
      return;
    }
    if (new Date(dateFrom) > new Date(dateTo)) {
      toast.error("Start date cannot be after the end date.");
      return;
    }

    setLoading(true);

    const data = {
      user_id: user?.id,
      currency,
      date_from: dateFrom,
      date_to: dateTo,
      email: user?.email,
    };

    const action =
      statementType === "wallet"
        ? generateWalletStatement
        : generateInvestmentStatement;

    dispatch(
      action({
        data,
        callback: () => {
          setLoading(false);
          onClose();
        },
        failed: () => {
          setLoading(false);
        },
      })
    );
  };

  const dateBoxStyle = {
    display: "flex",
    border: "1px solid #D0D5DD",
    borderRadius: "7px",
    padding: "10px 12px",
    width: "100%",
    marginTop: "6px",
  };

  const selectStyle = {
    border: "1px solid #D0D5DD",
    borderRadius: "7px",
    padding: "12px",
    width: "100%",
    marginTop: "6px",
    outline: "none",
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="generate-statement-modal-title"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          maxWidth: "92%",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{ position: "absolute", top: 19, right: 10 }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full" style={{ padding: "10px 20px" }}>
          <h1 className="font-semibold text-2xl mb-1">Generate Statement</h1>
          <p className="text-sm text-[#667085] mb-5">
            The statement will be sent to {user?.email || "the user's email"} in
            a few minutes.
          </p>

          <div className="mb-4">
            <label className="font-medium">Statement Type</label>
            <select
              value={statementType}
              onChange={(e) => setStatementType(e.target.value)}
              style={selectStyle}
            >
              {statementOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-4">
            <label className="font-medium">Currency</label>
            <select
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
              style={selectStyle}
            >
              {currencyOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="flex gap-4 mb-6">
            <div className="flex-1">
              <label className="font-medium">Start Date</label>
              <div style={dateBoxStyle}>
                <input
                  type="date"
                  value={dateFrom}
                  max={dateTo || undefined}
                  onChange={(e) => setDateFrom(e.target.value)}
                  style={{ width: "100%", outline: "none" }}
                />
              </div>
            </div>
            <div className="flex-1">
              <label className="font-medium">End Date</label>
              <div style={dateBoxStyle}>
                <input
                  type="date"
                  value={dateTo}
                  min={dateFrom || undefined}
                  onChange={(e) => setDateTo(e.target.value)}
                  style={{ width: "100%", outline: "none" }}
                />
              </div>
            </div>
          </div>

          <div className="flex w-full items-center">
            <CustomButton
              variant="outlined"
              customColor="#fff"
              children="Cancel"
              width="100%"
              onClick={onClose}
              height="50px"
              borderColor="#D0D5DD"
              margin="0px 25px 0px 0px"
              color="#159AA8"
            />
            <CustomButton
              variant="contained"
              customColor="#159AA8"
              loading={loading}
              children="Generate Statement"
              width="100%"
              height="50px"
              padding="10px"
              onClick={handleGenerate}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default GenerateStatementModal;
